var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useState } from 'react';
import { useEventCallback } from '../useEventCallback';
/**
 * a method for trigger force update
 * @returns force update method
 */
export function useForceUpdate() {
    var _a = __read(useState(Object.create(null)), 2), dispatch = _a[1];
    var memoizedDispatch = useEventCallback(function () {
        dispatch(Object.create(null));
    });
    return memoizedDispatch;
}
